import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  AppointmentApiService,
  AuthApiService,
  CustomerApiService,
  FeedbackApiService,
  StoreApiService,
} from './v2';
import { API_V1, API_V2 } from './api.conf';

@NgModule({
  imports: [CommonModule],
  providers: [
    AppointmentApiService,
    FeedbackApiService,
    StoreApiService,
    AuthApiService,
    CustomerApiService,
    {
      provide: API_V1,
      useValue: '/api/v1',
    },
    {
      provide: API_V2,
      useValue: '/api/v2',
    },
  ],
})
export class ApiModule {}
